import { Binder } from '@ribajs/core'

/**
 * Binder to show the shopify consent banner
 */
export class ShowConsentSettingsBinder extends Binder<
  undefined,
  HTMLButtonElement
> {
  static key = 'show-consent-settings'

  bind() {
    this.onClick = this.onClick.bind(this)
  }

  async routine(el: HTMLButtonElement) {
    el.addEventListener('click', this.onClick)
  }

  async onClick(event: Event) {
    event.preventDefault()
    try {
      if (!window.privacyBanner) {
        this.el.innerText =
          'No privacy banner found, please disable your ad blocker'
        return
      }
      window.privacyBanner.showPreferences()
    } catch (error) {
      console.error(error)
      this.el.innerText =
        (error as Error).message ||
        'Du hast deine Einstellung bereits gespeichert'
    }
  }
}
